import gql from "graphql-tag";

export const GET_PUBLISHED_PHOTO_DATA = gql`
    query getPublishedPhotoData($creator: String!, $limit: Int) {
        photos: browsePhotosByCreator(creator: $creator, limit: $limit) {
            items {
                slugWithId
                title
                ratio
                assets {
                    thumbnailMedium
                }
            }
            totalCount
        }
    }
`;
